import PropTypes from 'prop-types';
import React from 'react';
import { deepPure } from '~/util';
import { ChartRangeItem2 } from './ChartRangeItem2';
import { useVariantStyles } from './hooks/useVariantStyles';

export const STYLED_CHART_RANGE_ITEM_VARIANT = {
  WHITE: 'WHITE',
  PURPLE: 'PURPLE',
  BLANK: 'BLANK'
};

export const StyledChartRangeItem2 = ({
  classes: classesOverrides,
  variant = STYLED_CHART_RANGE_ITEM_VARIANT.WHITE,
  backgroundImageOverride,
  ...props
}) => {
  const variantClasses = useVariantStyles({
    variant,
    classesOverrides
  });

  return (
    <ChartRangeItem2
      {...props}
      classes={variantClasses}
      backgroundImageOverride={backgroundImageOverride}
    />
  );
};

StyledChartRangeItem2.propTypes = {
  classes: PropTypes.object,
  variant: PropTypes.oneOf(Object.values(STYLED_CHART_RANGE_ITEM_VARIANT)),
  backgroundImageOverride: PropTypes.string,
  props: PropTypes.object
};

export default deepPure(StyledChartRangeItem2);
